import { getSavedTourists } from 'src/routes/Checkout/store/selectors/data';
import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { deleteSavedTouristAction } from 'src/routes/Checkout/store/client/slice';
import TouristName from './TouristNameField';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  tourists: getSavedTourists(state),
});

const mapDispatchToProps = (dispatch) => ({
  deleteSavedTourist: (tourist) => {
    dispatch(deleteSavedTouristAction(tourist));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TouristName);
